import { render } from "./MarkRequiredFieldModal.vue?vue&type=template&id=4561562e&scoped=true"
import script from "./MarkRequiredFieldModal.vue?vue&type=script&lang=js"
export * from "./MarkRequiredFieldModal.vue?vue&type=script&lang=js"

import "./MarkRequiredFieldModal.vue?vue&type=style&index=0&id=4561562e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4561562e"]])

export default __exports__